import Element from "state/ui/editor/elements/Element";
import AudioInEditorContext from "views/components/Editor/elements/Audio/AudioInEditorContext";

class AudioElement extends Element {
  static RESTRICTIONS = [
    "removable",
    "visibility", // Audio elements are never visible on canvas
    "opacity",
    "angle",
    "duplicate",
    "sizeAndPosition", // Audio elements don't have visual positioning
    "filters",
    "flipping",
    "cropping",
    "setAsBackground",
    "imageUpload",
    "outline"
  ];

  updateAttributes(attributes) {
    return new this.constructor({
      ...this,
      ...attributes
    });
  }

  // Override getLayerTree to show audio-specific information
  getLayerTree() {
    return {
      ...super.getLayerTree(),
      type: "audio",
      name: this.filename || this.name || "Audio Track",
      duration: this.duration,
      delay: this.delay || 0,
      isMuted: this.isMuted || false
    };
  }

  render(props) {
    // Audio elements render as invisible components for playback only.
    // key is required because RenderContainer.render maps page elements
    // to .render() output without wrapping in DraggableElement (which is
    // what supplies the key for every other element type).
    return (
      <AudioInEditorContext
        key={this.uniqueId}
        elementData={this}
        {...props}
      />
    );
  }
}

export default AudioElement;
